"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var Text_1 = require("../Text");
var styles_1 = __importDefault(require("./styles"));
exports.Toast = react_1.default.memo(function (_a) {
    var open = _a.open, _b = _a.anchorOrigin, anchorOrigin = _b === void 0 ? { horizontal: 'right', vertical: 'bottom' } : _b, message = _a.message, _c = _a.withFab, withFab = _c === void 0 ? true : _c, _d = _a.autoHideDuration, autoHideDuration = _d === void 0 ? null : _d, _e = _a.color, color = _e === void 0 ? '#fff' : _e, _f = _a.backgroundColor, backgroundColor = _f === void 0 ? '#495057' : _f, _g = _a.icon, icon = _g === void 0 ? (0, jsx_runtime_1.jsx)(icons_1.CheckCircle, {}) : _g, _h = _a.type, type = _h === void 0 ? 'success' : _h, rest = __rest(_a, ["open", "anchorOrigin", "message", "withFab", "autoHideDuration", "color", "backgroundColor", "icon", "type"]);
    var classes = (0, styles_1.default)({ color: color, backgroundColor: backgroundColor, withFab: withFab, type: type });
    var getIconFromType = (0, react_1.useCallback)(function () {
        switch (type) {
            case 'error':
                return (0, jsx_runtime_1.jsx)(icons_1.Error, {});
                break;
            case 'custom':
                return icon;
                break;
            case 'success':
            default:
                return (0, jsx_runtime_1.jsx)(icons_1.CheckCircle, {});
                break;
        }
    }, [icon, type]);
    return ((0, jsx_runtime_1.jsx)(core_1.Snackbar, __assign({ open: open, anchorOrigin: anchorOrigin, className: classes.snackbar, autoHideDuration: autoHideDuration }, rest, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ role: "alert", className: classes.root }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: classes.icon, "data-testid": "toast-icon" }, { children: getIconFromType() })), (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ size: "medium", "data-testid": "toast-message" }, { children: message }))] })) })));
});
